"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyAddressValuationEnquiryInput = instanceOfPropertyAddressValuationEnquiryInput;
exports.PropertyAddressValuationEnquiryInputFromJSON = PropertyAddressValuationEnquiryInputFromJSON;
exports.PropertyAddressValuationEnquiryInputFromJSONTyped = PropertyAddressValuationEnquiryInputFromJSONTyped;
exports.PropertyAddressValuationEnquiryInputToJSON = PropertyAddressValuationEnquiryInputToJSON;
exports.PropertyAddressValuationEnquiryInputToJSONTyped = PropertyAddressValuationEnquiryInputToJSONTyped;
/**
 * Check if a given object implements the PropertyAddressValuationEnquiryInput interface.
 */
function instanceOfPropertyAddressValuationEnquiryInput(value) {
    return true;
}
function PropertyAddressValuationEnquiryInputFromJSON(json) {
    return PropertyAddressValuationEnquiryInputFromJSONTyped(json, false);
}
function PropertyAddressValuationEnquiryInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'level': json['level'] == null ? undefined : json['level'],
        'unitNumber': json['unitNumber'] == null ? undefined : json['unitNumber'],
        'streetNumber': json['streetNumber'] == null ? undefined : json['streetNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'suburb': json['suburb'] == null ? undefined : json['suburb'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
    };
}
function PropertyAddressValuationEnquiryInputToJSON(json) {
    return PropertyAddressValuationEnquiryInputToJSONTyped(json, false);
}
function PropertyAddressValuationEnquiryInputToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'level': value['level'],
        'unitNumber': value['unitNumber'],
        'streetNumber': value['streetNumber'],
        'street': value['street'],
        'suburb': value['suburb'],
        'postcode': value['postcode'],
    };
}
